<app-mat-spinner-overlay *ngIf="isLoading"></app-mat-spinner-overlay>

<div class="duplicate-document-report-page">
  <div class="header-container">
    <h1 class="page-title">Duplicate Document Report</h1>
    <p class="page-subtitle">
      Click on a duplicate count to view repeated document numbers.
    </p>
  </div>

  <div class="document-card-grid" *ngIf="summaryDocuments.length; else noDataFound">
    <div
      class="document-card"
      *ngFor="let documentRow of summaryDocuments"
      [style.--doc-color]="getDocumentColor(documentRow.Doc_Name)"
    >
      <div class="card-header">
        <div class="doc-icon-wrapper">
          <i class="fas" [ngClass]="getDocumentIcon(documentRow.Doc_Name)"></i>
        </div>
        <h3 class="document-name">{{ documentRow.Doc_Name || "-" }}</h3>
      </div>

      <div class="document-count-row">
        <span class="count-label">Total Duplicates</span>
        <button
          type="button"
          class="count-badge"
          (click)="onDocumentCountClick(documentRow)"
          title="View detailed breakdown"
        >
          {{ documentRow.Duplicate_Count || 0 }}
        </button>
      </div>
    </div>
  </div>

  <ng-template #noDataFound>
    <div class="empty-state">
      <i class="fas fa-folder-open"></i>
      No duplicate document data available at this time.
    </div>
  </ng-template>
</div>

<!-- Second Modal: Document Details -->
<div
  *ngIf="showDetailModal"
  class="modal fade in show"
  tabindex="-1"
  role="dialog"
  style="display: block; background: rgba(0, 0, 0, 0.5)"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-list-ul mr-2"></i>
          {{ selectedDocumentName }} Breakdown
        </h5>
        <button type="button" class="close modal-close-btn" (click)="closeDetailModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="table-responsive">
          <table class="table detail-table">
            <thead>
              <tr>
                <th style="width: 60px">#</th>
                <th>Document Number</th>
                <th>Repeats</th>
                <th style="width: 100px">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detailRow of selectedDocumentDetails; let index = index">
                <td>{{ index + 1 }}</td>
                <td>
                  <strong>{{
                    detailRow.KYC_DocNumber ||
                      detailRow.Doc_No ||
                      detailRow.Document_No ||
                      detailRow.DocNumber ||
                      detailRow.KYC_Doc_No ||
                      "-"
                  }}</strong>
                </td>
                <td>
                  <span class="badge-repeat">
                    {{
                      detailRow.Total_count ||
                        detailRow.Duplicate_Count ||
                        detailRow.Repeat_Count ||
                        detailRow.Count ||
                        detailRow.DuplicateCount ||
                        0
                    }} Times
                  </span>
                </td>
                <td>
                  <button
                    type="button"
                    class="action-btn"
                    (click)="onViewCustomerDetails(detailRow)"
                    title="View Customers"
                  >
                    <i class="fas fa-eye"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!selectedDocumentDetails.length">
                <td colspan="4" class="text-center py-5">
                  <i class="fas fa-info-circle mr-2"></i> No details found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Third Modal: Customer Details -->
<div
  *ngIf="showCustomerDetailModal"
  class="modal fade in show"
  tabindex="-1"
  role="dialog"
  style="display: block; background: rgba(0, 0, 0, 0.6)"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-users mr-2"></i>
          Linked Customers ({{ selectedDocNumber }})
        </h5>
        <button type="button" class="close modal-close-btn" (click)="closeCustomerDetailModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="table-responsive">
          <table class="table detail-table">
            <thead>
              <tr>
                <th style="width: 50px">#</th>
                <th>Customer Name</th>
                <th>Phone No</th>
                <th>KYC Doc</th>
                <th>Document</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let customerRow of customerDetails; let rowIndex = index">
                <td>{{ rowIndex + 1 }}</td>
                <td>{{ customerRow.CustomerName || customerRow.Customer_Name || "-" }}</td>
                <td>{{ customerRow.Customer_PhoneNo || customerRow.PhoneNo || "-" }}</td>
                <td>{{ customerRow.KYC_DocNumber || "-" }}</td>
                <td>{{ customerRow.Doc_Name || "-" }}</td>
                <td class="address-col">{{ customerRow.Address || "-" }}</td>
              </tr>
              <tr *ngIf="!customerDetails.length">
                <td colspan="6" class="text-center py-5">
                  <i class="fas fa-user-slash mr-2"></i> No customer details found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
